function getIframeDocument(iframe) {
  return iframe.contentDocument || iframe.contentWindow.document;
}

export default getIframeDocument;
